export const GERMAN_IBAN_REGEX = /^DE([0-9a-zA-Z]\s?){20}$/;

export const GERMAN_ZIPCODE_REGEX = /^[0-9]{5}$/;

// Mirrors the legacy react-forms-state phone validation
// (react-forms-state/src/FormUtils.tsx) — applied after stripping whitespace.
export const PHONE_NUMBER_REGEX = /^(\+?[0-9])[0-9\-/]*$/;
